/**
 * ESM entry matching old react-hot-toast/dist/index.mjs path.
 * Backed by Sonner for the app-wide premium toaster.
 */
import { toast as sonnerToast, Toaster as SonnerToaster } from "sonner";

function mapOptions(opts) {
  if (!opts || typeof opts !== "object") return undefined;
  return { ...opts };
}

function toast(message, opts) {
  return sonnerToast(message, mapOptions(opts));
}

toast.success = (message, opts) =>
  sonnerToast.success(message, mapOptions(opts));
toast.error = (message, opts) => sonnerToast.error(message, mapOptions(opts));
toast.message = (message, opts) =>
  sonnerToast.message(message, mapOptions(opts));
toast.info = (message, opts) =>
  typeof sonnerToast.info === "function"
    ? sonnerToast.info(message, mapOptions(opts))
    : sonnerToast(message, mapOptions(opts));
toast.warning = (message, opts) =>
  typeof sonnerToast.warning === "function"
    ? sonnerToast.warning(message, mapOptions(opts))
    : sonnerToast(message, mapOptions(opts));
toast.loading = (message, opts) =>
  sonnerToast.loading(message, mapOptions(opts));
toast.custom = (renderer, opts) =>
  sonnerToast.custom(renderer, mapOptions(opts));
toast.promise = (promise, msgs) => sonnerToast.promise(promise, msgs);
toast.dismiss = (id) => sonnerToast.dismiss(id);
toast.remove = (id) => sonnerToast.dismiss(id);

export function Toaster() {
  return null;
}

export { toast, SonnerToaster };
export default toast;
